<template>
<div>
    <div class="form-title">
        <template v-if="modalTitle != undefined && modalTitle != ''">
            <span id="laborHrHeader">{{modalTitle}}</span>
        </template>
    </div>
    <form autocomplete="off" class="form-horizontal basic-form-container form-custom-select" id="laborHourForm">
        <div class="col form-group">
            <p>&nbsp;</p>
            <template v-if="modalLabor != undefined && modalLabor != ''">
                <div class="form-group">
                    <label class="control-label" for="wo_no">Technician:</label>
                    <span>{{modalLabor}}</span>
                </div>
            </template>
        </div>
        <div class="col form-group">
            <template  v-for="(lVal,lKey) in hoursArr">
                <div v-bind:key="lKey" class="form-row">
                    <div class="col-md-5 form-group">
                        <label class="control-label require">Date:</label>
                        <div class="input-group">
                            <template v-if="lVal.is_first == 1">
                                <date-picker placeholder="MM/DD/YYYY" :id="'date_added'+lKey" name="date_added" v-model="lVal.date_added" :config="optionsExpiryDate" aria-describedby="basic-addon3" class='cal-icon' disabled="true"></date-picker>
                                <label for="date_added" class="fp-calendar input-calender-icon"></label>
                            </template>
                            <template v-else>    
                                <date-picker placeholder="MM/DD/YYYY" :id="'date_added'+lKey" name="date_added" v-model="lVal.date_added" :config="optionsExpiryDate" aria-describedby="basic-addon3" class='cal-icon'></date-picker>
                                <label for="date_added" class="fp-calendar input-calender-icon"></label>
                            </template>    
                        </div>
                        <div class="field-error">{{lVal.labor_date_error_msg}}</div>
                    </div>
                    <div class="col-md-4 form-group">
                        <label class="control-label require" for="hours">Hours:</label>
                        <input type="text" class="form-control" v-model="lVal.hours" :id="'hours'+lKey" placeholder="Enter Hours" name="hours" @keypress="isAmountCheck($event)">
                        <div class="field-error">{{lVal.labor_hour_error_msg}}</div>
                    </div>
                    <div class="col-md-3 form-group mt-4">
                        <label class="control-label"></label>
                        <template v-if="lVal.is_first == 1">
                            <button type="submit" :id="'addHour'+lKey" class="btn btn-primary" v-on:click.prevent="addLaborHour(lKey)">
                                <i class="fp-add"> </i>
                            </button>
                        </template>
                        <template v-else>
                            <a href="javascript:void()" class="fp-remove color-red close-icon" v-on:click.prevent="removeLaborHour(lKey)"></a>
                        </template>    
                    </div>        
                </div>    
            </template>    
        </div>    
        <div class="btn-groups">
            <button type="submit" id="saveLaborDetailsBtn"  class="btn btn-primary" v-on:click.prevent="saveLaborDetailsBtn" >
                <i class="fp-save"> </i>Save
            </button>

            <button type="submit" id="cancelLaborHrBtn" class="btn btn-tertiary" v-on:click.prevent="cancelLaborHrBtn" >
                <i class="fp-close"> </i>  Cancel
            </button>
        </div>
    </form>
</div>    
</template>
<script>
import Vue from "vue";
import {commonMixins} from '../mixins/commonMixins';
export default {
    name: "CustomerEstimateLaborHour",
    mixins:[commonMixins],
    props: {
        estLineItem: {
            type: String,
            required: false,
            default:undefined
        },
        estLineLabor: {
            type: String,
            required: false,
            default:undefined
        },
        estLineHour: {
            type: Array,
            required: false,
            default:undefined
        },
        estLineObj:{
            type: Object,
            required: false,
            default:undefined
        }
    },
    data() {
        return {
            modalTitle:"Update Labor Hours",
            modalLabor:"",
            hoursArr:[],
            itemObj:{},
            optionsExpiryDate: {
                format: 'MM/DD/YYYY',
                useCurrent: false,
            },
            openDateVal:""
        }
    },
    mounted: function(){
        var self = this;        
        self.modalTitle = self.estLineItem;
        self.modalLabor = self.estLineLabor;
        self.itemObj = self.estLineObj;
        self.openDateVal = self.estLineObj.openDate;
        self.hoursArr = [];
        for(var i = 0;i < self.estLineHour.length;i++){
            self.hoursArr.push(self.estLineHour[i]);
        }
    },
    methods: {
        saveLaborDetailsBtn() {
            var self = this;
            var error = false;
            for(var i = 0;i < self.hoursArr.length;i++){
                self.hoursArr[i].labor_date_error_msg = ""
                self.hoursArr[i].labor_hour_error_msg = "";

                if (!self.hoursArr[i].date_added || self.hoursArr[i].date_added == null || self.hoursArr[i].date_added == "") {
                    self.hoursArr[i].labor_date_error_msg = "Date Required.";
                    error = true;
                }else{
                    if (i != 0) {
                        if (Date.parse(self.hoursArr[i].date_added) <= Date.parse(self.openDateVal)) {
                            self.hoursArr[i].labor_date_error_msg = "Date should be greater than Open Date.";
                            error = true;
                        }
                    }
                }

                if (!self.hoursArr[i].hours || self.hoursArr[i].hours == null || self.hoursArr[i].hours == "") {
                    self.hoursArr[i].labor_hour_error_msg = "Hours Required.";
                    error = true;
                }
            }
            if (!error) {
                self.$parent.storeLaborLog(self.itemObj.laborInd,self.itemObj.taskInd,self.hoursArr);
            }
        },
        cancelLaborHrBtn() {
            var self = this;
            self.$parent.hideLaborLogModal(self.itemObj.laborInd,self.itemObj.taskInd);
            self.modalTitle = "";
            self.modalLabor = "";
            self.hoursArr = [];
            self.itemObj = {};
        },
        addLaborHour(laborInd) {
            var self = this;
            var laborHrIndex = self.hoursArr.length - 1;
            if (self.hoursArr.length > 0) {
                var error = false;
                self.hoursArr[laborHrIndex].labor_date_error_msg = "";
                self.hoursArr[laborHrIndex].labor_hour_error_msg = "";

                if (!self.hoursArr[laborHrIndex].date_added || self.hoursArr[laborHrIndex].date_added == null || self.hoursArr[laborHrIndex].date_added == "") {
                    self.hoursArr[laborHrIndex].labor_date_error_msg = "Date Required.";
                    error = true;
                }

                if (!self.hoursArr[laborHrIndex].hours || self.hoursArr[laborHrIndex].hours == null || self.hoursArr[laborHrIndex].hours == "") {
                    self.hoursArr[laborHrIndex].labor_hour_error_msg = "Hours Required.";
                    error = true;
                }

                if (!error) {
                    self.hoursArr.push({
                        labor_hour_id:0,
                        hours:"",
                        date_added:"",
                        labor_date_error_msg:"",
                        labor_hour_error_msg:"",
                        is_first:0
                    });
                }
            }
        },
        removeLaborHour(laborInd){
            var self = this;
            if (self.hoursArr[laborInd] != undefined && self.hoursArr[laborInd] != null) {
                if (self.hoursArr[laborInd].labor_hour_id != undefined && self.hoursArr[laborInd].labor_hour_id != null) {
                    if (self.hoursArr[laborInd].labor_hour_id == 0) {
                        self.hoursArr.splice(laborInd, 1);
                    }else{
                        var params = self.hoursArr[laborInd].labor_hour_id;
                        if (params != null && params != "") {
                            if (confirm('Are you sure that you want to remove this? ')) {

                                self.hoursArr.splice(laborInd, 1);

                            }
                        }
                    }
                }
            }
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/CustomerEstimateLaborHour.vue